var map = {
	"./chrome_store.jpg": "./src/assets/chrome_store.jpg",
	"./chrome_store@2x.jpg": "./src/assets/chrome_store@2x.jpg",
	"./default-favicon.png": "./src/assets/default-favicon.png",
	"./favicon/android-chrome-192x192.png": "./src/assets/favicon/android-chrome-192x192.png",
	"./favicon/android-chrome-512x512.png": "./src/assets/favicon/android-chrome-512x512.png",
	"./favicon/apple-touch-icon.png": "./src/assets/favicon/apple-touch-icon.png",
	"./favicon/browserconfig.xml": "./src/assets/favicon/browserconfig.xml",
	"./favicon/chrome_extension_icon.png": "./src/assets/favicon/chrome_extension_icon.png",
	"./favicon/favicon-16x16.png": "./src/assets/favicon/favicon-16x16.png",
	"./favicon/favicon-32x32.png": "./src/assets/favicon/favicon-32x32.png",
	"./favicon/favicon.ico": "./src/assets/favicon/favicon.ico",
	"./favicon/mstile-144x144.png": "./src/assets/favicon/mstile-144x144.png",
	"./favicon/mstile-150x150.png": "./src/assets/favicon/mstile-150x150.png",
	"./favicon/mstile-310x150.png": "./src/assets/favicon/mstile-310x150.png",
	"./favicon/mstile-310x310.png": "./src/assets/favicon/mstile-310x310.png",
	"./favicon/mstile-70x70.png": "./src/assets/favicon/mstile-70x70.png",
	"./favicon/safari-pinned-tab.svg": "./src/assets/favicon/safari-pinned-tab.svg",
	"./favicon/site.webmanifest": "./src/assets/favicon/site.webmanifest",
	"./fonts/PPMori-Regular.eot": "./src/assets/fonts/PPMori-Regular.eot",
	"./fonts/PPMori-Regular.woff": "./src/assets/fonts/PPMori-Regular.woff",
	"./fonts/PPMori-Regular.woff2": "./src/assets/fonts/PPMori-Regular.woff2",
	"./fonts/PPMori-RegularItalic.eot": "./src/assets/fonts/PPMori-RegularItalic.eot",
	"./fonts/PPMori-RegularItalic.woff": "./src/assets/fonts/PPMori-RegularItalic.woff",
	"./fonts/PPMori-RegularItalic.woff2": "./src/assets/fonts/PPMori-RegularItalic.woff2",
	"./fonts/PPMori-SemiBold.eot": "./src/assets/fonts/PPMori-SemiBold.eot",
	"./fonts/PPMori-SemiBold.woff": "./src/assets/fonts/PPMori-SemiBold.woff",
	"./fonts/PPMori-SemiBold.woff2": "./src/assets/fonts/PPMori-SemiBold.woff2",
	"./fonts/PPMori-SemiBoldItalic.eot": "./src/assets/fonts/PPMori-SemiBoldItalic.eot",
	"./fonts/PPMori-SemiBoldItalic.woff": "./src/assets/fonts/PPMori-SemiBoldItalic.woff",
	"./fonts/PPMori-SemiBoldItalic.woff2": "./src/assets/fonts/PPMori-SemiBoldItalic.woff2",
	"./shlk_logo.jpg": "./src/assets/shlk_logo.jpg",
	"./shlk_logo.mp4": "./src/assets/shlk_logo.mp4",
	"./svg/avatar_placeholder.svg": "./src/assets/svg/avatar_placeholder.svg",
	"./svg/flag_fi_16.svg": "./src/assets/svg/flag_fi_16.svg",
	"./svg/icon/avatar.svg": "./src/assets/svg/icon/avatar.svg",
	"./svg/icon/caret-down.svg": "./src/assets/svg/icon/caret-down.svg",
	"./svg/icon/caret-left.svg": "./src/assets/svg/icon/caret-left.svg",
	"./svg/icon/caret-right.svg": "./src/assets/svg/icon/caret-right.svg",
	"./svg/icon/compact.svg": "./src/assets/svg/icon/compact.svg",
	"./svg/icon/cross.svg": "./src/assets/svg/icon/cross.svg",
	"./svg/icon/cross_16.svg": "./src/assets/svg/icon/cross_16.svg",
	"./svg/icon/enter.svg": "./src/assets/svg/icon/enter.svg",
	"./svg/icon/full.svg": "./src/assets/svg/icon/full.svg",
	"./svg/icon/google.svg": "./src/assets/svg/icon/google.svg",
	"./svg/icon/link.svg": "./src/assets/svg/icon/link.svg",
	"./svg/icon/logout.svg": "./src/assets/svg/icon/logout.svg",
	"./svg/icon/more.svg": "./src/assets/svg/icon/more.svg",
	"./svg/icon/search.svg": "./src/assets/svg/icon/search.svg",
	"./svg/icon/snooze.svg": "./src/assets/svg/icon/snooze.svg",
	"./svg/logo-compact.svg": "./src/assets/svg/logo-compact.svg",
	"./svg/logo.svg": "./src/assets/svg/logo.svg",
	"./svg/w_love_14.svg": "./src/assets/svg/w_love_14.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets sync recursive ^\\.\\/.*$";